// extracted by mini-css-extract-plugin
module.exports = {"hero":"frontpage_hero__1FuFq","content":"frontpage_content__Ot4b2","container":"frontpage_container__Szdnh","heading":"frontpage_heading__3Vh4k","form":"frontpage_form__1fJXj"};